import {
  Box,
  Button,
  Grid,
} from "@mui/material";

const ActionButton = ({children, ...props}) => {
  return (
    <Grid 
      size={1}
    >
      <Button
        fullWidth
        variant="outlined"
        sx={{
          lineHeight: 1.2,
          height: 1,
          justifyContent: "left",
        }}
        { ...props }
      >
        <Box sx={{
          marginX: "auto"
        }}>{ children }</Box>  
      </Button>
    </Grid>
  );
}

export default ActionButton;